import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-es-ct",
  "use": "icon-icon-es-ct-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-es-ct\">\n  <path fill=\"#fcdd09\" d=\"M0 0h512v512H0z\" />\n  <path stroke=\"#da121a\" stroke-width=\"60\" d=\"M0 90h810m0 120H0m0 120h810m0 120H0\" transform=\"scale(.6321 .94815)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol